import { Stack } from '@mui/material';
import React from 'react';
import TopLevelTemplateComponentProps, {
  ContentProps,
  TopLevelTemplateContentProps,
} from '../../models/TopLevelTemplateComponentProps';
import FootnoteRenderer from '../FootnoteRenderer';
import { Palette } from 'Palette';
import StyledSection from '../styles/StyledSection';
import StandardHeaderContentList from './StandardHeaderContentList';
import StandardHeaderHeadingBlock from './StandardHeaderHeadingBlock';

export interface StandardHeaderContent extends TopLevelTemplateContentProps {
  content: ContentProps | ([ContentProps, ContentProps[]] | ContentProps)[];
  openSimplified?: boolean;
}

export interface StandardHeaderTextProps
  extends StandardHeaderContent, TopLevelTemplateComponentProps {
  onUpdate?: (json: StandardHeaderTextProps, focusElement?: string, selectAll?: boolean) => void;
  tone?: keyof typeof Palette;
}

export default function StandardHeaderText({
  heading,
  content,
  id,
  tone = 'tone1',
  footnotes,
  firstElement,
}: StandardHeaderTextProps) {
  if (!content) return null;
  return (
    <StyledSection
      id={id}
      noSidePaddingFrom="xs"
      noTopPadding={!firstElement}
      tone={tone}
      additionalClassName="standard-header-text-section content-management-item"
    >
      <Stack className="standard-header-text">
        <StandardHeaderHeadingBlock heading={heading} tone={tone} />
        <StandardHeaderContentList content={content} footnotes={footnotes} />
        <FootnoteRenderer footnotes={footnotes} tone={tone} />
      </Stack>
    </StyledSection>
  );
}
